/*
 * View for a list of topics
 */

define([
  "marionette",
  "modules/topicsSplit/topics/topicsList/template/topicsListTemplate.html",
], function (Marionette, TopicsListTemplate) {
  var TopicsListView = {};

  TopicsListView.topicsListLayout = Marionette.Layout.extend({
    template: TopicsListTemplate,
    regions: {
      controls: "#topicsControls",
      list: "#list",
    },
  });

  return TopicsListView;
});
